
import { Vue, Component, Prop } from 'vue-property-decorator';
import { SavedDocumentDto } from '@/features/shipment/services/document-library.service';
import QuickActionItem from './QuickActionItem.vue';

export interface QuickActionDoc {
  id: string | number;
  name: string;
  documentType?: string;
  isAutoGenerated: boolean;
  isUsmca: boolean;
  libraryDoc?: SavedDocumentDto;
}

@Component({
  components: { QuickActionItem },
})
export default class QuickActionsPanel extends Vue {
  @Prop({ default: () => [] }) documents!: QuickActionDoc[];

  @Prop({ default: () => new Set() }) addedDocumentIds!: Set<string>;

  @Prop({ default: () => new Set() }) loadingIds!: Set<string>;

  @Prop({ default: false }) isLoading!: boolean;

  @Prop({ default: false }) hasLibraryDocs!: boolean;

  @Prop({ default: false }) isMaxReached!: boolean;

  private static readonly MAX_VISIBLE = 5;

  // eslint-disable-next-line global-require
  private emptyIllustrationSrc = require('@/assets/images/electronic-trade-documents/quick-actions-empty.png');

  get autoGeneratedDocs(): QuickActionDoc[] {
    return this.documents.filter((d) => d.isAutoGenerated);
  }

  get savedDocs(): QuickActionDoc[] {
    return this.documents.filter((d) => !d.isAutoGenerated);
  }

  get visibleAutoGeneratedDocs(): QuickActionDoc[] {
    return this.autoGeneratedDocs.slice(0, QuickActionsPanel.MAX_VISIBLE);
  }

  get visibleSavedDocs(): QuickActionDoc[] {
    const remaining = QuickActionsPanel.MAX_VISIBLE - this.visibleAutoGeneratedDocs.length;
    return remaining > 0 ? this.savedDocs.slice(0, remaining) : [];
  }
}
